/// <reference path="index.d.ts" />

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from 'react-redux'
import { store } from './redux/store'

import Layout from './layout'
import './index.scss'

// 注入redux
const Root = (props:any) => {  
  return <Provider store={store}><Layout {...props}/></Provider>
}

if ( window.__getComponentInNode ) {
    window.__getComponentInNode( Root );
} else {
    ReactDOM.render(
        <Root {...window.detailData}/>,
        document.getElementById( "container" )
    );
}
